import { Typography, Grid, Box, Paper, Skeleton } from "@mui/material";
import AreaCard from "../../components/AreaCard";
import {
  AreaCardProps,
  AreaDataModel,
  IAreaRequest,
  IDistrictData,
} from "../../models";
import { ArrowRight, KeyboardArrowLeft } from "@mui/icons-material";
import { useState, useEffect } from "react";

import SubAreaRegions from "../../components/SubAreaRegions";
import {
  homepageActions,
  selectAreas,
  selectDistricts,
  selectKeywords,
  selectLoading,
} from "../../saga/homepageSlice";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { Link, useNavigate } from "react-router-dom";
import { ISearchFilter } from "features/searchStore/models";
import { searchStoreActions } from "features/searchStore/saga/searchStoreSlice";
import { mockKeyword } from "features/homepage/mockupApis";

const subRegion1 = ["北海道", "青森", "秋田", "山形", "岩手", "宮城", "福島"];

const subRegion2 = ["東京", "神奈川", "埼玉", "千葉", "栃木", "茨城", "群馬"];

const subRegion3 = [
  "愛知",
  "岐阜",
  "静岡",
  "三重",
  "新潟",
  "山梨",
  "長野",
  "石川",
  "富山",
  "福井",
];

const subRegion4 = ["大阪", "兵庫", "京都", "滋賀", "奈良", "和歌山"];

const subRegion5 = [
  "岡山",
  "広島",
  "鳥取",
  "島根",
  "山口",
  "香川",
  "徳島",
  "愛媛",
  "高知",
];

const subRegion6 = [
  "福岡",
  "佐賀",
  "長崎",
  "熊本",
  "大分",
  "宮崎",
  "鹿児島",
  "沖縄",
];

export function SearchByArea() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const areaList = useAppSelector(selectAreas);
  const keywordList = mockKeyword;
  const districtList = useAppSelector(selectDistricts);
  const isLoading = useAppSelector(selectLoading);

  const [selectedArea, setSelectedArea] = useState<string | null>();
  const [areaLabel, setAreaLabel] = useState<string | null>();
  const [storeNumOfSelected, setstoreNumOfSelected] = useState<number | null>();
  const [selected, setSelected] = useState(false);

  const handleSelectedArea = (
    value: string,
    label: string,
    storeNum: number
  ) => {
    setSelectedArea(value);
    setAreaLabel(label);
    setstoreNumOfSelected(storeNum);
    setSelected(true);
    dispatch(homepageActions.getDistricts(0));
    dispatch(homepageActions.getKeywords(value));
  };

  const handleSelectedDistrict = (e: IDistrictData) => {
    const filterValue: ISearchFilter = {
      area: {
        value: e.PK,
        label: e.Name,
      },
      minBudget: 0,
      maxBudget: 0,
      sort_code: 0,
      genres: [],
      conditions: [],
      scenes: [],
    };
    dispatch(searchStoreActions.setSearchFilter(filterValue));
    navigate("/stores");
  };

  useEffect(() => {
    dispatch(homepageActions.getAreas(6));
    if (selectedArea && selectedArea != null) {
      dispatch(homepageActions.getDistricts(0));
    }
  }, [dispatch, selectedArea]);

  return (
    <Box position="relative">
      <Box
        sx={{
          position: "relative",
          opacity: selected ? 0 : 1,
          transition: ".3s",
          transform: selected ? "translateX(-30px)" : "",
          transitionDelay: selected ? "" : ".2s",
          pointerEvents: selected ? "none" : "",
          zIndex: 2,
        }}
      >
        <Typography variant="h4" fontWeight="bold">
          エリアから探す
        </Typography>
        <Grid container spacing={2} rowSpacing={5} sx={{ my: 2 }}>
          {areaList &&
            areaList.map((e) => (
              <Grid key={e.label} item xs={12} xl={4} lg={4} md={6} sm={6}>
                <AreaCard
                  label={e.label}
                  value={e.value}
                  image={e.image}
                  storeNum={e.storeNum}
                  handleOnClick={handleSelectedArea}
                />
              </Grid>
            ))}
        </Grid>

        <Grid container spacing={2} sx={{ my: 2 }}>
          <Grid item xs={6}>
            <SubAreaRegions
              key={"北海道・東北"}
              name="北海道・東北"
              subRegions={subRegion1}
              handleOnClick={handleSelectedArea}
            />
          </Grid>
          <Grid item xs={6}>
            <SubAreaRegions
              key="中部"
              name="中部"
              subRegions={subRegion3}
              handleOnClick={handleSelectedArea}
            />
          </Grid>
          <Grid item xs={6}>
            <SubAreaRegions
              key="中国・四国"
              name="中国・四国"
              subRegions={subRegion5}
              handleOnClick={handleSelectedArea}
            />
          </Grid>

          <Grid item xs={6}>
            <SubAreaRegions
              key="関東"
              name="関東"
              subRegions={subRegion2}
              handleOnClick={handleSelectedArea}
            />
          </Grid>
          <Grid item xs={6}>
            <SubAreaRegions
              key="関西"
              name="関西"
              subRegions={subRegion4}
              handleOnClick={handleSelectedArea}
            />
          </Grid>
          <Grid item xs={6}>
            <SubAreaRegions
              key="九州・沖縄"
              name="九州・沖縄"
              subRegions={subRegion6}
              handleOnClick={handleSelectedArea}
            />
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          opacity: selected ? 1 : 0,
          transition: ".3s",
          transform: selected ? "" : "translateX(30px)",
          transitionDelay: selected ? ".2s" : "",
          // animation: "topAreaFadeIn .4s ease-out .4s 1 normal forwards",
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          marginBottom={3}
          sx={{
            cursor: "pointer",
            "&:hover": {
              "& > .go-back": {
                color: "primary.main",
                textDecoration: "underline",
              },
            },
          }}
          onClick={() => setSelected(false)}
        >
          <KeyboardArrowLeft />
          {/* <Typography color="blue">Go back</Typography> */}
          <Typography className="go-back" color="blue">
            都道府県一覧に戻る
          </Typography>
        </Box>
        <Box
          display="flex"
          flex={1}
          flexDirection="column"
          border={1}
          p={3}
          borderColor="divider"
          borderRadius={2}
          bgcolor="white"
        >
          <Box display="flex" alignItems="center" marginBottom={3}>
            <Typography
              fontWeight="bold"
              fontSize="25px"
              sx={{
                marginRight: 4,
                marginLeft: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {areaLabel}
            </Typography>

            <Typography
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {storeNumOfSelected?.toLocaleString()}
            </Typography>
            <Typography
              variant="caption"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {selectedArea && "件"}
            </Typography>
          </Box>

          {isLoading ? (
            <Skeleton
              animation="wave"
              variant="rounded"
              height="300px"
              width="850px"
            />
          ) : (
            <>
              {" "}
              <Box display="flex" flexWrap="wrap">
                {districtList &&
                  districtList.map((e) => (
                    <Box
                      key={e.PK}
                      sx={{
                        padding: 1,
                        m: 1,
                        border: 1,
                        borderRadius: 2,
                        borderColor: "divider",
                        "&:hover": {
                          cursor: "pointer",
                          color: "primary.main",
                          borderColor: "primary.main",
                        },
                      }}
                      onClick={() => handleSelectedDistrict(e)}
                    >
                      <Typography
                        fontSize="15px"
                        lineHeight="21px"
                        fontWeight="bold"
                      >
                        {e.Name}
                      </Typography>
                    </Box>
                  ))}
              </Box>
              <Grid container display="flex">
                {keywordList.map((e) => (
                  <Grid item xs={2} display="flex" alignItems="center">
                    <ArrowRight
                      style={{
                        color: "orange",
                      }}
                    />
                    <Typography
                      component={Link}
                      to=""
                      textTransform="none"
                      color="blue"
                      textAlign="start"
                      fontSize="12px"
                      lineHeight="16.8px"
                      sx={{
                        m: 1,
                        textDecoration: "none",
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                    >
                      {e}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
